// Per-layout registry of ONLY the sections that have their own independent
// Builder visibility toggle (i.e. can actually go hidden and turn a navLink
// into a dead anchor). Static sections (diet-selection/delivery-zone/
// perfect-plan/how-it-works/etc.) are deliberately NOT listed — they can
// never be hidden, so a navLink pointing at one carries no risk and doesn't
// need a registry entry; an admin linking to one just uses "Custom URL".
//
// `value` is an arbitrary stable key for the Select control; `href` is the
// real anchor stored on the navLink when this option is picked — must stay
// in sync with each brand's real `id="..."` anchor (ck-v2/e4f-v2's
// chef-kitchen.tsx, meelz-client-v2's app/[locale]/(app)/page.tsx) and with
// the `sectionKey` used by that repo's own navbar-section.tsx auto-hide
// filter (useSectionConfig("quiz"/"faq")).
export const SECTION_ANCHOR_CUSTOM_VALUE = "__custom__";

export const SECTION_ANCHORS_BY_LAYOUT = {
    ck: [
        { value: "quiz", label: "Quiz (Find My Plan)", href: "/#wellness-quiz" },
        { value: "faq",  label: "FAQ",                 href: "/#faq-section" },
    ],
    e4f: [
        { value: "quiz", label: "Quiz (Find My Plan)", href: "/#wellness-quiz" },
        { value: "faq",  label: "FAQ",                 href: "/#faq-section" },
    ],
    meelz: [
        { value: "quiz", label: "Quiz (Find My Plan)", href: "/#menu" },
        { value: "faq",  label: "FAQ",                 href: "/#faq" },
    ],
};

// Builds the Select's option list for a given layout id: its registered
// section anchors plus the always-present "Custom URL" escape hatch for
// external links, other pages, or static (non-hideable) sections. Each
// option keeps its real `href` (not just {value, label}) so CardsEditor can
// reverse-lookup which option matches a navLink's already-stored href —
// this is what makes existing, already-published navLinks show up correctly
// pre-selected the first time this picker renders, with zero data
// migration: the underlying `href` string never changes shape, only how
// it's edited.
export function buildSectionAnchorOptions(layoutId) {
    const registered = SECTION_ANCHORS_BY_LAYOUT[layoutId] || [];
    return [
        ...registered,
        { value: SECTION_ANCHOR_CUSTOM_VALUE, label: "Custom URL…", href: null },
    ];
}
